import ethUsdc from "../../images/eth-usdc.png";
import {
  arbFactories,
  arbFactoryController,
  arbLendingPools,
  goerFactories,
  goerFactoryController,
  goerLendingPools,
} from "./internalAddresses";
import { wethToken, usdcToken, uniToken, daiToken } from "./tokens";
import { ALL_UNI_POOLS, ALL_TOKENS } from "./externalAddresses";
import { SupportedChainId } from "./chains";

const ARBITRUM_PAIRS = [
  {
    label: "ETH/USDC",
    rate: 0.05,
    pairId: "ETH-USDC-500",
    src: ethUsdc,
    uniPairId: "UNISWAP3ETH:WETHUSDC",
    uniPoolAddress: ALL_UNI_POOLS[SupportedChainId.ARBITRUM_ONE].WETH_USDC_500,
    token: "USDC",
    decimal: 6,
    factoryAddress: arbFactories.WETH_USDC,
    lendingPoolAddress: arbLendingPools.WETH,
    wantToken: {
      ...usdcToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].USDC,
    },
    borrowToken: {
      ...wethToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].WETH,
    },
    deployedChainId: SupportedChainId.ARBITRUM_ONE,
  },
  {
    label: "ETH/USDC",
    rate: 0.3,
    pairId: "ETH-USDC-3000",
    src: ethUsdc,
    uniPairId: "UNISWAP3ETH:WETHUSDC",
    uniPoolAddress: ALL_UNI_POOLS[SupportedChainId.ARBITRUM_ONE].WETH_USDC_3000,
    token: "USDC",
    decimal: 6,
    factoryAddress: "",
    lendingPoolAddress: arbLendingPools.WETH,
    wantToken: {
      ...usdcToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].USDC,
    },
    borrowToken: {
      ...wethToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].WETH,
    },
    deployedChainId: SupportedChainId.ARBITRUM_ONE,
  },
];

const GOERLI_PAIRS = [
  {
    label: "ETH/UNI",
    rate: 0.05,
    pairId: "ETH-UNI-500",
    src: ethUsdc,
    uniPairId: "UNISWAP3ETH:WETHUSDC",
    uniPoolAddress: ALL_UNI_POOLS[SupportedChainId.GOERLI].WETH_UNI,
    token: "UNI",
    decimal: 18,
    factoryAddress: goerFactories.WETH_UNI,
    lendingPoolAddress: goerLendingPools.WETH,
    wantToken: {
      ...uniToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].UNI,
    },
    borrowToken: {
      ...wethToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].WETH,
    },
    deployedChainId: SupportedChainId.GOERLI,
  },
  {
    label: "ETH/DAI",
    rate: 0.05,
    pairId: "ETH-DAI-500",
    src: ethUsdc,
    uniPairId: "UNISWAP3ETH:WETHUSDC",
    uniPoolAddress: ALL_UNI_POOLS[SupportedChainId.GOERLI].WETH_DAI,
    token: "DAI",
    decimal: 18,
    factoryAddress: goerFactories.WETH_DAI,
    lendingPoolAddress: goerLendingPools.WETH,
    wantToken: {
      ...daiToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].DAI,
    },
    borrowToken: {
      ...wethToken,
      tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].WETH,
    },
    deployedChainId: SupportedChainId.GOERLI,
  },
];

export const ALL_PAIRS: { [key: number]: PairProps[] } = {
  [SupportedChainId.ARBITRUM_ONE]: ARBITRUM_PAIRS,
  [SupportedChainId.GOERLI]: GOERLI_PAIRS,
};

export const ALL_CONTROLLERS: { [key: number]: string } = {
  [SupportedChainId.ARBITRUM_ONE]: arbFactoryController,
  [SupportedChainId.GOERLI]: goerFactoryController,
};

export type PairProps = {
  label: string;
  rate: number;
  pairId: string;
  src: string;
  uniPairId: string;
  uniPoolAddress: string;
  token: string;
  decimal: number;
  factoryAddress: string;
  lendingPoolAddress: string;
  wantToken: {
    tokenSymbol: string;
    tokenFullName: string;
    tokenDecimal: number;
    tokenAddress: string;
    tokenIcon: string;
  };
  borrowToken: {
    tokenSymbol: string;
    tokenFullName: string;
    tokenDecimal: number;
    tokenAddress: string;
    tokenIcon: string;
  };
  deployedChainId: number;
};

export const defaultPair: PairProps = {
  label: "",
  rate: 0,
  pairId: "",
  src: "",
  uniPairId: "",
  uniPoolAddress: "",
  token: "",
  decimal: 0,
  factoryAddress: "",
  lendingPoolAddress: "",
  wantToken: {
    tokenSymbol: "",
    tokenFullName: "",
    tokenDecimal: 0,
    tokenAddress: "",
    tokenIcon: "",
  },
  borrowToken: {
    tokenSymbol: "",
    tokenFullName: "",
    tokenDecimal: 0,
    tokenAddress: "",
    tokenIcon: "",
  },
  deployedChainId: 0,
};
